import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Slider from '../Components/SliderDetailedLawyers';

const DetailedCardPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { image, headtitle, title, paragraph, content } = location.state || {};

  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
  }, []);
  

 
const renderParagraph = (para) => {
  // Only handle lists here
  if (para.includes('<li>')) {
    // 1) remove the <ul> wrappers
    const cleanedContent = para.replace(/<\/?ul[^>]*>/g, '');

    // 2) split on each </li>
    const items = cleanedContent.split('</li>').map((item, index) => {
      // strip the opening <li>…
      let cleanedItem = item.replace(/<li[^>]*>/, '').trim();

      // 3) if it starts with a <p><strong>…</strong></p>, pull that out
      const headingMatch = cleanedItem.match(
        /^<p><strong>(.*?)<\/strong><\/p>(.*)$/s
      );
      if (headingMatch) {
        const [, headingText, rest] = headingMatch;
        // render bullet + real <strong> + the rest of the text
        return (
          <div key={index} className="mb-2">
            • <strong>{headingText}</strong>
            {rest ? ` ${rest.trim().replace(/<\/?[^>]+>/g, '')}` : ''}
          </div>
        );
      }

      // 4) otherwise strip any tags and render as plain text bullet
      const plainText = cleanedItem.replace(/<\/?[^>]+>/g, '');
      return plainText ? (
        <div key={index} className="mb-2">• {plainText}</div>
      ) : null;
    });

    return <div className="mb-4 text-left ml-5 mt-5">{items}</div>;
  }

  // fallback for non-lists (if you need it)
  return <div className="mb-4 text-left ml-5 mt-5">{para.replace(/<\/?[^>]+>/g, '')}</div>;
};


  
const styles = `
  @keyframes scaleUp {
    from {
      transform: scale(1);
    }
    to {
      transform: scale(1.05);
    }
  }

  .hover-card {
    transition: transform 0.3s ease;
  }

  .hover-card:hover {
    animation: scaleUp 0.3s ease forwards;
  }
`;

const enhanceHtml = (html) => {
  return html
    .replace(/<h1>/g, '<h1 class="text-4xl font-bold">')
    .replace(/<li>/g, '<li class="list-disc list-inside">');
    
};

  

  if (!image) {
    return <div>Loading...</div>;
  }

  return (
    <div className="container bg-[#777777] items-center mx-auto xl:max-w-7xl w-full px-0 md:px-0 xl:px-0 pb-20" style={{ backgroundColor: 'white' }}>
      <Slider Lawyers={`${headtitle} Profile `} />
      <div className="bg-white p-6 mt-5 md:mt-20">
  <div className="flex flex-col md:flex-row items-center mb-6">
    <div className="md:w-1/3 w-full mb-4 md:mb-0">
      <img src={image} alt={headtitle} className="w-full h-auto object-cover rounded-lg shadow-md" />
    </div>
    <div className="md:w-2/3 w-full md:ml-6">
      <h1 className="font-bold text-xl md:text-3xl mt-4 mb-2 text-center md:text-left" style={{ fontFamily: 'Arial' }}>{headtitle}</h1>
      <h2 className="text-md md:text-xl mb-4 text-center md:text-left" style={{ fontFamily: 'Arial' }}>{title}</h2>
      <div className="text-center md:text-start">
  <div className="border-b-4 inline-block w-20 mb-4 mx-auto" style={{ borderColor: '#972a36'}}></div>

  <p className="text-sm mb-1" dangerouslySetInnerHTML={{ __html: enhanceHtml(paragraph) }}></p>
</div>

    </div>
  </div>
  <div className="border-t border-gray-300 pt-4" style={{ fontFamily: 'Arial' }}>

    <p className="px-0 md:px-8" style={{ textAlign: 'justify', textJustify: 'inter-word', fontFamily: 'Arial' }} dangerouslySetInnerHTML={{ __html: enhanceHtml(content) }}></p>
  </div>
</div>

    </div>
  );
};

export default DetailedCardPage;
